module.exports = __webpack_public_path__ + "img/hr-heat-pipe-straight-vertical-2.f6cf796a.png";